
<template>
    <v-autocomplete
      ref="autocomplete"
      density="compact"
      variant="outlined"
      v-bind="$attrs"
      :items="sortedItems"
      :item-title="getItemTitle"
      :item-value="getItemValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :rules="rules"
      :multiple="multiple"
      :modelValue="modelValue"
      v-model:search="searchQuery"
      @update:menu="onMenuUpdate"
      @update:modelValue="onSelect"
    ></v-autocomplete>
</template>
<script>
export default {
    props: {
      items: { default: () => [] },
      itemTitle: { type: [String, Function], default: 'name' },
      itemValue: { type: [String, Function], default: 'id' },
      placeholder: { default: '' },
      disabled: { default: false },
      rules: { default: () => [] },
      modelValue: { default: null },
      multiple: { type: Boolean, default: false },
    },
    emits: ['update:modelValue', 'change'],
    computed: {
      sortedItems() {
        if (!Array.isArray(this.items) || this.items.length === 0) return this.items;
        return [...this.items].sort((a, b) => {
          const titleA = String(this.getItemTitle(a) ?? '').toLowerCase();
          const titleB = String(this.getItemTitle(b) ?? '').toLowerCase();
          return titleA.localeCompare(titleB);
        });
      },
    },
    data() {
      return {
        searchQuery: null,
      };
    },
    watch: {
      modelValue() {
        if (this.multiple) {
          this.clearSearch();
        }
      },
    },
    methods: {
      clearSearch() {
        if (this.multiple) {
          this.searchQuery = "";
          this.$nextTick(() => {
            this.searchQuery = "";
          });
        }
      },
      onMenuUpdate(isOpened) {
        if (!isOpened && this.multiple) {
          this.clearSearch();
        }
      },
      getItemTitle(item) {
        if (item === null || item === undefined) return "";
        const raw = (typeof item === "object" && item !== null && "raw" in item && item.raw !== undefined) ? item.raw : item;
        if (typeof this.itemTitle === "function") return this.itemTitle(raw);
        if (typeof raw !== "object" || raw === null) return String(raw);
        const titleKey = this.itemTitle;
        if (titleKey && raw[titleKey] !== undefined) return raw[titleKey];
        return raw.name ?? raw.label ?? raw.text ?? raw.title ?? raw.value ?? raw.id ?? String(raw);
      },
      getItemValue(item) {
        if (item === null || item === undefined) return null;
        const raw = (typeof item === "object" && item !== null && "raw" in item && item.raw !== undefined) ? item.raw : item;
        if (typeof this.itemValue === "function") return this.itemValue(raw);
        if (typeof raw !== "object" || raw === null) return raw;
        const valueKey = this.itemValue;
        if (valueKey && raw[valueKey] !== undefined) return raw[valueKey];
        return raw.id ?? raw.value ?? raw.key ?? raw.name ?? raw;
      },
      onSelect(val) {
        if (this.multiple) {
          this.clearSearch();
        }
        this.$emit('update:modelValue', val);
        this.$emit('change', val);
      }
    }
}
</script>
<style scoped>
>>>.v-field__outline {
    --v-field-border-width: 0px !important;
    border: 10px !important;
    --v-field-border-opacity: 0.38;
    align-items: stretch;
    contain: layout;
    display: flex;
    /* background-color:#ECECEC; */
    /* height: 100%;
     left: 0;
    pointer-events: none;
    position: absolute;
    right: 0; 
    width: 100%;
    border: 0px solid #D7D6D6 !important;
    border-radius: 8px !important; */
}

>>>.v-field {
    cursor: text;
    background: #ECECEC !important;
    font-size: 14px;
    color: #777777;
    border-radius: 8px;
}

>>>.v-field:focus-within {
    cursor: text;
    background-color: #ffffff !important;
    border: 2px solid #3C5AAA !important;
    border-radius: 8px;
}

>>>.v-field--disabled {
    pointer-events: none;
    opacity: 0.8 !important;
}
</style> 

